import { render, staticRenderFns } from "./contentMenu.vue?vue&type=template&id=310f13fb&scoped=true"
import script from "./contentMenu.vue?vue&type=script&lang=js"
export * from "./contentMenu.vue?vue&type=script&lang=js"
import style0 from "./contentMenu.vue?vue&type=style&index=0&id=310f13fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310f13fb",
  null
  
)

export default component.exports